import 'date-input-polyfill'
import 'lazysizes'
import hamburger from './components/hamburger'
import submenu from './components/submenu'
import accordion from "./components/accordion";
import './components/parallax'
import './components/theme-switch'

hamburger() // Hamburger menu
submenu() // Mobile submenu accordions
accordion() // Accordions